module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Basel Saleh","short_name":"Basel Saleh","start_url":"/","display":"minimal-ui","icon":"E:\\bsaleh03.github.io\\gatsby-all-in\\static\\logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"571844736afc608a3c07d07ec137e538"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
